import React, { useState } from "react";
import { Button, Typography } from "@material-ui/core";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import MobileLayout from "../MobileLayout";
import { GameFrame } from "./GameFrame";
import { useBreefDetails } from "./gameService";
import { MAX_PRACTICE_ROUNDS, practiceRoundsTaken } from "./StartAGame";
import analytics from "../analytics/track";

// The practice round: the same game, short, and it doesn't count. Afterwards: try again (at most 2 practice
// rounds in all) or start the real game. Same layout as the game screen.
const primary = { backgroundColor: "#EB6608", color: "#FFFFFF", width: "100%", textTransform: "none" as const, height: "3rem", borderRadius: "10px", fontSize: "1.05rem" };
const secondary = { color: "#EB6608", borderColor: "#EB6608", width: "100%", textTransform: "none" as const, height: "3rem", borderRadius: "10px", fontSize: "1.05rem" };

const PracticeScene = () => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const breef = useBreefDetails();
  const game = breef?.gameId;
  const seconds = game?.practiceSeconds || 10;
  const [attempt, setAttempt] = useState(() => {
    const next = practiceRoundsTaken() + 1;
    sessionStorage.setItem("practiceRounds", String(next));
    return next;
  });
  const [practiceScore, setPracticeScore] = useState<number | null>(null);

  const again = () => {
    const next = practiceRoundsTaken() + 1;
    sessionStorage.setItem("practiceRounds", String(next));
    setPracticeScore(null);
    setAttempt(next);
  };

  return (
    <MobileLayout>
      {/* The practice round gets the screen too - only the banner tells it apart from the real game */}
      <div style={{ display: "flex", flexDirection: "column", height: "100dvh" }}>
        <Typography align="center" style={{ fontFamily: "Roboto", color: "#EB6608", fontWeight: 700, padding: "0.6rem 0", flexShrink: 0 }}>
          {t("gamePlay.practiceBanner", { seconds })}
        </Typography>
        <div style={{ flex: 1, minHeight: 0, backgroundColor: "#FFFFFF", overflow: "hidden" }}>
          {game?.gameCode && practiceScore === null && (
            <GameFrame
              key={attempt}
              gameCode={game.gameCode}
              mode="practice"
              seconds={seconds}
              round={`practice-${attempt}`}
              onScore={(score) => {
                setPracticeScore(score);
                analytics.track("Game practice finished", { current_page: "game-practice", game_name: game?.gameName, practice_score: score });
              }}
              onGiveUp={() => navigate("/game-scene")}
            />
          )}
          {practiceScore !== null && (
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%", padding: "1.5rem", gap: "0.8rem", fontFamily: "Roboto, Arial, sans-serif", textAlign: "center" }}>
              <Typography style={{ fontSize: "1.6rem", fontFamily: "Roboto" }}>{t("gamePlay.practiceScore", { score: practiceScore })}</Typography>
              <Typography style={{ fontFamily: "Roboto", color: "#666" }}>{t("gamePlay.practiceNotCounted")}</Typography>
              <Button variant="contained" style={primary} onClick={() => navigate("/game-scene")}>
                {t("gamePlay.startReal")}
              </Button>
              {practiceRoundsTaken() < MAX_PRACTICE_ROUNDS && (
                <Button variant="outlined" style={secondary} onClick={again}>
                  {t("gamePlay.practiceAgain")}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </MobileLayout>
  );
};

export default PracticeScene;
